<template>
  <div class="app flex-row align-items-center">
    <notifications />
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit.prevent="login">
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                    <b-input-group-text><i class="fa fa-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input :class="{ 'is-invalid' : $v.form.username.$error }" id="input1UserName" v-model="form.username" type="text" class="form-control" placeholder="Username"  autocomplete="username email"  aria-describedby="input1UserName" />
                    <b-form-invalid-feedback id="input1UserName">
                       This is a required field
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fa fa-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input :class="{ 'is-invalid' : $v.form.password.$error }" id="input1Password" v-model="form.password" type="password" class="form-control" placeholder="Password" autocomplete="current-password"  aria-describedby="input1Password" />
                    <b-form-invalid-feedback id="input1Password">
                       This is a required field
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col align="center">
                      <b-button type=submit variant="primary"  class="px-4">Login</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'  
import { validationMixin } from 'vuelidate';  
import { required, minLength } from 'vuelidate/lib/validators';
import { getResponseMessages } from '../_helpers';
export default {
  name: 'Login',
  data() {
    return {
      form: {
        username:'',
        password:''
      }
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(2)
      },
      password: {
        required
      }
    }  
  },
  methods: {
    ...mapActions('auth', ['login']),
    login() {
      this.$v.form.$touch();
      if(this.$v.form.$error) return
      const { username, password } = this.form   
      this.$store.dispatch('login', { username, password }).then((res) => {
        this.$toastr('success', getResponseMessages(res.data.messages), 'Success')
        this.$router.push('/home')
      },(error) =>{
        this.$toastr('error', getResponseMessages(error.data.messages), 'Error')
      });
    }
  },
}
</script>